/* Sparq Wear — "Kartla öde" ve "Kapıda öde" butonları (ürün sayfası ve sepet) */
(() => {
  if (window.__sqwPay) return;
  window.__sqwPay = true;

  const t = (k, fb) => (window.SparqWearStrings && window.SparqWearStrings[k]) || fb;
  const COD_TEXT = /kap[ıi]da\s*ödeme|kap[ıi]da\s*öde/i;

  /* Releasit'in sayfaya eklediği kapıda ödeme butonunu bul (bizimkiler hariç) */
  const findReleasit = (scope = document) =>
    [...scope.querySelectorAll('button, a, [role="button"]')].find(
      (b) => !b.closest('[data-sqw-pay], [data-sqw-cart-pay]') && COD_TEXT.test(b.textContent || '')
    );

  /* Releasit'in sepet butonu: ürün ekleme formlarının dışında olan */
  const findReleasitCart = () =>
    [...document.querySelectorAll('button, a, [role="button"]')].find(
      (b) =>
        !b.closest('[data-sqw-pay], [data-sqw-cart-pay], form[action*="/cart/add"], product-form-component, [data-sqw-upsell]') &&
        COD_TEXT.test(b.textContent || '')
    );
  /* Releasit sepet formunu aç. Releasit, sayfadaki ilk "sepete ekle" formunu (ör. öneri kartı)
     ürün sayfası sanıp o ürünü sepete ekliyor; tıklama süresince bu formları devre dışı bırak. */
  const openReleasitCart = (b) => {
    const forms = [...document.querySelectorAll('form[action*="/cart/add"]')];
    forms.forEach((f) => {
      f.dataset.sqwAction = f.getAttribute('action');
      f.setAttribute('action', '/cart/add-off');
    });
    b.click();
    setTimeout(() => forms.forEach((f) => f.setAttribute('action', f.dataset.sqwAction)), 5000);
  };
  const cartUrl = () => (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';

  /* Sepet sayfasına ?sqw_cod=1 ile gelindiyse, Releasit sepet butonu yüklenince formu aç */
  if (/[?&]sqw_cod=1/.test(location.search)) {
    try {
      history.replaceState(null, '', location.pathname);
    } catch (e) {}
    /* Releasit butonu görünse bile dinleyicisi geç bağlanabilir: form açılana kadar dene */
    let tries = 0;
    const formOpen = () => {
      const f = document.getElementById('rsi_form_wrapper');
      return !!(f && f.offsetHeight > 0);
    };
    const iv = setInterval(() => {
      if (formOpen() || ++tries > 20) return clearInterval(iv);
      const b = findReleasitCart();
      if (b) openReleasitCart(b);
    }, 1000);
  }

  /* Releasit butonlarını gizle (tetiklemeyi bizim butonlar yapar) */
  const proxyReleasit = () => {
    if (!document.querySelector('[data-sqw-pay], [data-sqw-cart-pay]')) return;
    document.querySelectorAll('button, a, [role="button"]').forEach((b) => {
      if (b.closest('[data-sqw-pay], [data-sqw-cart-pay]')) return;
      if (COD_TEXT.test(b.textContent || '') && !b.classList.contains('sqw-rsi-proxied')) {
        const wrap = b.closest('[class*="_rsi"], [class*="rsi-"]') || b;
        wrap.classList.add('sqw-rsi-proxied');
        b.setAttribute('tabindex', '-1');
      }
    });
  };
  /* Sözleşme onayı: sepet yeniden çizilse de hatırlanır */
  const KEY = 'sqwConsent';
  const getConsent = () => {
    try {
      return sessionStorage.getItem(KEY) === '1';
    } catch (e) {
      return false;
    }
  };
  const applyConsent = () => {
    const on = getConsent();
    document.querySelectorAll('[data-sqw-consent]').forEach((c) => {
      if (c.checked !== on) c.checked = on;
    });
    document.querySelectorAll('[data-sqw-cart-card], [data-sqw-cart-cod]').forEach((b) => {
      const v = on ? 'false' : 'true';
      if (b.getAttribute('aria-disabled') !== v) b.setAttribute('aria-disabled', v);
    });
    if (on) document.querySelectorAll('[data-sqw-consent-warning]').forEach((w) => (w.hidden = true));
  };
  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-sqw-consent]')) return;
    try {
      sessionStorage.setItem(KEY, e.target.checked ? '1' : '0');
    } catch (err) {}
    applyConsent();
  });
  const mo = new MutationObserver(() => {
    proxyReleasit();
    applyConsent();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  proxyReleasit();
  applyConsent();

  const getForm = (root) => {
    const section = root.closest('.shopify-section') || document;
    return section.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  };

  const currentLine = (root) => {
    const form = getForm(root);
    const id = form && form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value;
    const qtyEl = form && (form.querySelector('[name="quantity"]') || document.querySelector('input[name="quantity"]'));
    const qty = Math.max(1, parseInt((qtyEl && qtyEl.value) || '1', 10));
    return { id, qty, form };
  };

  /* ---------- Paket (2 seçenek) ---------- */
  const bundleOf = (el) => {
    const section = (el && el.closest('.shopify-section')) || document;
    return section.querySelector('[data-sqw-bundle]');
  };
  /* Fırsat seçiliyse sepete eklenecek tüm satırlar; tek ürün seçiliyse null */
  const offerItems = (bundle, mainId) => {
    if (!bundle) return null;
    const on = bundle.querySelector('[data-sqw-offer-opt][value="2"]');
    if (!on || !on.checked) return null;
    const picks = [...bundle.querySelectorAll('[data-sqw-offer-variant]')].map((el) => el.value).filter(Boolean);
    const list = bundle.dataset.type === 'combo' ? [mainId, ...picks] : picks;
    const map = {};
    list.forEach((id) => (map[id] = (map[id] || 0) + 1));
    return Object.entries(map).map(([id, quantity]) => ({ id, quantity }));
  };
  const syncOffer = (bundle) => {
    bundle.querySelectorAll('.sqw-offer__opt').forEach((opt) => {
      opt.classList.toggle('is-active', opt.querySelector('input').checked);
    });
  };
  document.addEventListener('change', (e) => {
    const bundle = e.target.closest('[data-sqw-bundle]');
    if (bundle && e.target.matches('[data-sqw-offer-opt]')) syncOffer(bundle);
  });
  /* Seçim kutularına tıklamak radyoyu değiştirmesin */
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-sqw-offer-picks] select')) e.stopPropagation();
  }, true);

  /* Fırsat seçiliyken "Sepete ekle" paketteki tüm ürünleri ekler */
  document.addEventListener(
    'click',
    async (e) => {
      const add = e.target.closest('add-to-cart-component button, button[name="add"], .add-to-cart-button');
      if (!add || add.closest('[data-sqw-pay], [data-sqw-cart-pay], .quick-add-modal, [data-sqw-upsell]')) return;
      const bundle = bundleOf(add) || document.querySelector('[data-sqw-bundle]');
      const { id } = currentLine(add);
      const items = offerItems(bundle, id);
      if (!items || !window.SparqCart) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      add.setAttribute('aria-busy', 'true');
      try {
        await window.SparqCart.add(items);
      } catch (err) {
        alertStatus(add, err.message);
      } finally {
        add.removeAttribute('aria-busy');
      }
    },
    true
  );
  const alertStatus = (el, msg) => {
    const section = el.closest('.shopify-section') || document;
    const st = section.querySelector('[data-sqw-pay-status]');
    if (st) st.textContent = msg && msg !== 'error' ? msg : t('error', 'Bir sorun oluştu, lütfen tekrar dene.');
  };

  const setStatus = (root, msg) => {
    const s = root.querySelector('[data-sqw-pay-status]');
    if (s) s.textContent = msg || '';
  };

  const addToCart = async (id, qty, extras = []) => {
    const res = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: extras.length ? extras.map((x) => ({ id: Number(x.id), quantity: Number(x.quantity) })) : [{ id: Number(id), quantity: qty }] }),
    });
    if (!res.ok) {
      const j = await res.json().catch(() => ({}));
      throw new Error(j.description || j.message || 'error');
    }
    return res.json();
  };

  const openCartDrawer = () => {
    const trigger = [...document.querySelectorAll('#header-component button.header-actions__action, #header-component a.header-actions__action')].find(
      (b) => /sepet|cart/i.test(b.getAttribute('aria-label') || '')
    );
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    if (trigger) trigger.click();
    else window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
  };

  document.addEventListener('click', async (e) => {
    const card = e.target.closest('[data-sqw-pay-card]');
    const cod = e.target.closest('[data-sqw-pay-cod]');
    const cartCard = e.target.closest('[data-sqw-cart-card]');
    const cartCod = e.target.closest('[data-sqw-cart-cod]');
    if (!card && !cod && !cartCard && !cartCod) return;

    /* Sepetteki butonlar */
    if (cartCard || cartCod) {
      const wrap = (cartCard || cartCod).closest('[data-sqw-cart-pay]');
      const consent = document.querySelector('[data-sqw-consent]');
      if (consent && !consent.checked) {
        e.preventDefault();
        const warn = document.querySelector('[data-sqw-consent-warning]');
        if (warn) warn.hidden = false;
        consent.focus();
        return;
      }
      if (cartCard) {
        window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'checkout';
        return;
      }
      /* Sepet için yalnızca Releasit'in SEPET butonu kullanılır. Ürün formundaki buton
         o ürünü sepete bir kez daha ekler (ör. paket + fazladan 1 ürün). Ürün sayfasında
         sepet butonu yoksa sepet sayfasına gidip form orada açılır. */
      const r = findReleasitCart();
      if (!r) {
        window.location.href = cartUrl() + '?sqw_cod=1';
        return;
      }
      if (r) {
        openReleasitCart(r);
        setTimeout(() => {
          const f = document.getElementById('rsi_form_wrapper');
          const shown = f && f.offsetHeight > 0;
          const st = wrap && wrap.querySelector('[data-sqw-pay-status]');
          if (!shown && st) st.textContent = t('codSlow', 'Kapıda ödeme formu açılamadıysa sayfayı yenileyip tekrar dene ya da iletisim@sparqwear.store adresine yaz.');
        }, 3500);
      } else if (wrap) {
        const s = wrap.querySelector('[data-sqw-pay-status]');
        if (s) s.textContent = t('codMissing', 'Kapıda ödeme formu yükleniyor, lütfen birkaç saniye sonra tekrar dene.');
      }
      return;
    }

    /* Ürün sayfasındaki butonlar */
    const root = (card || cod).closest('[data-sqw-pay]');
    const btn = card || cod;
    const { id, qty } = currentLine(root);
    if (!id) return;
    const extras = offerItems(bundleOf(root), id) || [];

    if (cod && !extras.length) {
      const r = findReleasit(root.closest('.shopify-section') || document) || findReleasit();
      if (r) {
        r.click();
        return;
      }
    }

    btn.setAttribute('aria-busy', 'true');
    setStatus(root, t('adding', 'Sepete ekleniyor…'));
    try {
      if (cod && window.SparqCart) {
        await window.SparqCart.add(extras.length ? extras : [{ id, quantity: qty }]);
        setStatus(root, t('codInCart', 'Ürünler sepete eklendi. Sepetten "Kapıda öde" ile siparişini tamamlayabilirsin.'));
        return;
      }
      await addToCart(id, qty, extras);
      if (card) {
        setStatus(root, t('toCheckout', 'Güvenli ödeme sayfasına yönlendiriliyorsun…'));
        window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'checkout';
      } else {
        setStatus(root, t('codInCart', 'Ürün sepete eklendi. Sepetten "Kapıda öde" ile siparişini tamamlayabilirsin.'));
        openCartDrawer();
      }
    } catch (err) {
      setStatus(root, err.message && err.message !== 'error' ? err.message : t('error', 'Bir sorun oluştu, lütfen tekrar dene.'));
    } finally {
      btn.removeAttribute('aria-busy');
    }
  });
})();
